import servicioBase from '@/services/servicio-base'

const servicioCatalogo = {}

servicioCatalogo.obtenerDatosConfiguracion =  () => {
    return servicioBase.get('/configuracion/datos-cliente')
    .then(r => {
        return r.data
    })
    .catch(error => {
        return error
    })
}

export default servicioCatalogo